export const expoAccountNames = [
    "nuvemshop1",
    "nuvemshop2",
    "nuvemshop3",
    "nuvemshop4",
    "tray1",
    "tray2",
    "tray3",
    "tray4",
    "tray5",
    "tray6",
    "tray7",
    "webview1",
    "webview2",
    "webview3",
    "wix1",
    "convertr1",
    "convertr2",
    "lojaintegrada1",
    "lojaintegrada2",
    "irroba1"
]